import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  date: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(0),
    width: 200,
    collision: "fit",
  },
  time: {
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    width: 150,
    collision: "fit",
  },
}));

export default function DateAndTimePickers(props) {
  const classes = useStyles();
  var today = new Date();
  var start_date = "null";

  if (props.label === "בחר תאריך התחלה") {
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = yyyy + "-" + mm + "-" + dd;
  }
  if (props.label === "בחר תאריך סיום") {
    today = props.min;
  }
  return (
    <form className={classes.container} noValidate>
      <input
        id="date"
        label={props.label}
        name={props.name}
        type="date"
        variant="outlined"
        min={today}
        defaultValue={props.defValue}
        className={classes.date}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <input
        id="time"
        label={props.label}
        name={props.name}
        type="time"
        variant="outlined"
        defaultValue={props.defValue}
        className={classes.time}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </form>
  );
}
